import { IPubcenterSpacing } from '../../../../theme';
import { IOverviewPageStyleProps, IOverviewPageStyles } from './OverViewPage.types';

export const getStyles = (props: IOverviewPageStyleProps): IOverviewPageStyles => {
  const { theme } = props;
  const spacing = theme.spacing as IPubcenterSpacing;

  return {
    root: {
      gridRowGap: spacing.size16,
      width: '100%',
    },
    titleHeader: {
      alignItems: 'center',
      justifyContent: 'space-between',
      display: 'flex',
    },
  };
};
